<template>
  <div>
    <b-notification
      v-for="(error, index) in errors"
      v-bind:key="index"
      type="is-danger"
      aria-close-label="Close notification"
      role="alert"
      >{{ error.message }}</b-notification
    >
    <div>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(recoverPassword)">
          <ValidationProvider
            name="Email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <b-field :label="$t('Email')">
              <b-input v-model="form.email" />
            </b-field>

            <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
          </ValidationProvider>

          <b-field style="text-align: center;">
            <button
              native-type="submit"
              class="button is-pink is-full-w"
              :class="{ 'is-loading': isLoading }"
            >
              {{ $t('Cambiar contraseña') }}
            </button>
          </b-field>
          <b-field>
            <div class="control" style="margin-top: 10px;">
              <p>
                <a v-on:click="goToSignIn" class="customLink is-size-6"
                  >{{ $t('Identificarme') }}
                </a>
              </p>
            </div>
          </b-field>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { Auth } from 'aws-amplify'

extend('required', {
  ...required
})

extend('email', {
  ...email
})

export default {
  name: 'ForgotPassword',
  props: [],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {},
  data() {
    return {
      errors: [],
      isLoading: false,
      form: {
        email: ''
      }
    }
  },
  methods: {
    goToSignIn() {
      this.$router.push({ name: 'sign-in' })
    },
    async recoverPassword() {
      let self = this
      await Auth.forgotPassword(self.form.email)
        .then(function() {
          self.$router.push({
            name: 'change-password',
            query: { email: self.form.email }
          })
          self.$toast.open({
            duration: 5000,
            message: self.$t(`Revise su correo`),
            position: 'is-bottom',
            type: 'is-success'
          })
        })
        .catch(err => self.errors.push(err))
    }
  }
}
</script>
